var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 13.625V8C1.875 4.8934 4.39339 2.375 7.5 2.375C10.6066 2.375 13.125 4.8934 13.125 8C13.125 11.1066 10.6066 13.625 7.5 13.625H1.875ZM7.64206 9.28194L8.02288 10.4826H8.87831H8.88344C9.375 10.5 9.92094 9.93119 9.92094 9.44V6.97456C9.34512 6.97456 8.87831 7.44131 8.87831 8.01719V9.7535L7.39625 5.5323H6.16711L4.4325 10.4826H5.50581L5.88666 9.28194H7.64206ZM6.11171 8.50663L6.75225 6.47914H6.7765L7.417 8.50663H6.11171ZM9.92094 6.04878C9.92094 6.33401 9.68756 6.56524 9.39962 6.56524C9.11175 6.56524 8.87831 6.33401 8.87831 6.04878C8.87831 5.76353 9.11175 5.5323 9.39962 5.5323C9.68756 5.5323 9.92094 5.76353 9.92094 6.04878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatBot);
export default __webpack_public_path__ + "static/media/ai-chat-bot.4ca746f121e50bc23b0695c56f71479b.svg";
export { ForwardRef as ReactComponent };